export function formatCurrencyBRL(valor?: string | number): string {
  if (valor === undefined || valor === null || valor === '') {
    return 'R$ 0,00';
  }

  if (typeof valor === 'number') {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(valor);
  }

  let raw = String(valor)
    .trim()
    .replace(/[^\d.,-]/g, '');

  const hasComma = raw.includes(',');
  const hasDot = raw.includes('.');

  if (hasComma && hasDot) {
    if (raw.lastIndexOf(',') > raw.lastIndexOf('.')) {
      raw = raw.replace(/\./g, '').replace(',', '.');
    } else {
      raw = raw.replace(/,/g, '');
    }
  } else if (hasComma) {
    raw = raw.replace(',', '.');
  }

  const numericValue = Number(raw);

  if (Number.isNaN(numericValue)) {
    return 'R$ 0,00';
  }

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(numericValue);
}
